export const TableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: 'Expediente',
                    type: 'custom-html',
                    key: 'evaluation_testification',
                    modifier: (item) => {
                        return `${item.accreditation.record || ''}`;
                    }
                },
                {
                    title: 'OEC',
                    type: 'custom-html',
                    key: 'evaluation_testification',
                    modifier: (item) => {
                        return item.accreditation.organization.name;
                    }
                },
                {
                    title: 'Tipo',
                    type: 'custom-html',
                    key: 'evaluation_testification',
                    modifier: (item) => {
                        if(item.type == 'E'){
                            return 'Evaluación';
                        }else{
                            return 'Testificación';
                        }
                        
                    }
                },
                {
                    title: 'Codigo',
                    type: 'custom-html',
                    key: 'evaluation_testification',
                    modifier: (item) => {
                        return item.code;
                    }
                },
                {
                    title: 'Cargo evaluador',
                    type: 'custom-html',
                    key: 'evaluator_type',
                    modifier: (item) => {
                        return item.value;
                    }
                    
                },
                {
                    title: 'Fecha Evaluación',
                    type: 'custom-html',
                    key: 'date_performance',
                    modifier: (item) => {
                        return `${item}`;
                    }
                },
                {
                    title: 'Días',
                    type: 'custom-html',
                    key: 'performance_time',
                    modifier: (performance_time) => {
                        if (performance_time) {
                            const dateNow = new Date();
                            const days = performance_time.remaining_days;
                            if(days > 2 ) {
                                return `<span class="badge badge-sm badge-pill badge-success">${days}</span>`
                            } else if (days > 0 && days <= 2){
                                return `<span class="badge badge-sm badge-pill badge-warning">${days}</span>`
                            } else {
                                return `<span class="badge badge-sm badge-pill badge-danger">${days}</span>`
                            }
                        }
                    }
                    
                },

            ],
            actionObj: {
                title: this.$t('action'),
                type: 'action',
            }
        }
    },
}